import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBQ5m1-4wb5aKYNtyiTXC4BZJAzvMrffMU",
  authDomain: "dishastanesianket.firebaseapp.com",
  projectId: "dishastanesianket",
  storageBucket: "dishastanesianket.firebasestorage.app",
  messagingSenderId: "810586343428",
  appId: "1:810586343428:web:2cf28c5b549d680e00cd51",
  measurementId: "G-XVNLHJV4RS"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, addDoc };